import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const createBidApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.TICKET.CREATE_BID)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default createBidApi;
